<template>
  <router-view/>
</template>

<style lang="scss">
@use "./assets/all" as *;
</style>
